export const load = () => ({
	title: 'Say Yes to the #1 Window Replacement Alternative',
	showTitle: true,
});
